import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UtilityInlineGrid,
} from 'rhinostyle';

const CancelScheduledMessageModal = ({ open, onClose, onConfirm }) => (
  <Modal open={open}>
    <ModalHeader title="Cancel Scheduled Message?" onClose={onClose} />
    <ModalBody>
      <p className="u-text-center u-text-danger">This scheduled message will be permanently cancelled, and the action cannot be undone.</p>
    </ModalBody>
    <ModalFooter>
      <UtilityInlineGrid align="right">
        <Button onClick={onClose}>Close</Button>
        <Button type="danger" onClick={onConfirm}>Cancel Message</Button>
      </UtilityInlineGrid>
    </ModalFooter>
  </Modal>
);

CancelScheduledMessageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default CancelScheduledMessageModal;
